module.exports = __webpack_public_path__ + "static/media/sent mail.746aa48a.svg";